<template>
  <a-table
    class="labels-template-table"
    :columns="tableColumns"
    :data-source="tableData"
    :scroll="{ x: 'max-content' }"
    :row-class-name="(data: LabelTemplateTableData) => rowClass(data)"
    :pagination="false"
    :loading="
      labelTemplateStore.getAllCommonLabelTemplatesStatus ===
      enumStatusLoad.LOADING
    "
  >
    <template #headerCell="{ column }: TableHeaderCell<LabelTemplateTableData>">
      <LabelTemplateTableHeader
        :column="column"
        :is-admin-account="isAdminAccount"
      />
    </template>

    <template
      #bodyCell="{ record, column }: TableBodyCell<LabelTemplateTableData>"
    >
      <LabelTemplateTableCell
        :label="record"
        :column="column"
        :is-admin-account="isAdminAccount"
        :common="true"
      />
    </template>
  </a-table>
</template>

<script setup lang="ts">
import {
  type LabelTemplateTableData,
  useLabelTemplateStore,
} from "@/stores/labelTemplate/labelTemplateStore";
import { computed, onMounted } from "vue";
import LabelTemplateTableHeader from "@/components/settings/labels/labelTemplateTable/LabelTemplateTableHeader.vue";
import type { TableBodyCell, TableHeaderCell } from "@/types/table";
import LabelTemplateTableCell from "@/components/settings/labels/labelTemplateTable/LabelTemplateTableCell.vue";
import { enumStatusLoad } from "@/tools/enumStatusLoad";

const labelTemplateStore = useLabelTemplateStore();

const tableData = computed(() => labelTemplateStore.commonTableData);
const tableColumns = computed(() => labelTemplateStore.commonTableColumns);

const isAdminAccount = computed(() => labelTemplateStore.isAdminAccount);

const rowClass = (data: LabelTemplateTableData) =>
  labelTemplateStore.processingPersonalLabels.has(data.label.id)
    ? "disabled"
    : "";

onMounted(async () => {
  await labelTemplateStore.getAllCommonLabelTemplates();
});
</script>

<style scoped lang="scss"></style>
